import { Image, ShortName, TemplateStatus, Type } from "@/components/Cloud/Cloud.model";
import { PipesDisabledConfigType } from "../../types/Contract.config.types";
import { ComputeCatalogItem, ServerCatalogResponse } from "../../types/Contract.grapqhl.types";
import { CurrentProfile } from "../../types/Contract.types";
import { PipesGeneric } from "../../types/UiCloudMaterial.service.types";

export const imagesMock: Image[] = [
    {
        "id": "cl0r6t9lmv6a30999ktlxuzex",
        "type": Type.APP,
        "flags": [],
        "minRequirements": {
            "disk": 60,
            "vcpu": 1,
            "memory": 1024
        },
        "template": {
            "name": "aaaaaa",
            "description": "aaaa",
            "creationDate": "2022-03-14T20:50:14.437Z",
            "status": TemplateStatus.ACTIVE,
            "actions": {
                "cancel": true
            }
        },
        "operationalSystem": {
            "name": "Ubuntu Server",
            "shortName": ShortName.ubuntu,
            "version": "16.04 LTS",
            "arch": 64,
            "price": {
                "unitPrice": 17.9,
                "chargeType": "VCPU"
            }
        },
        "application": {
            "name": "Wordpress",
            "shortName": ShortName.wordpress,
            "version": "4.9.8",
            "link": "www.google.com.br",
            "price": {
                "unitPrice": 1,
                "chargeType": "VCPU"
            }
        }
    }
]

export const computesMock: ComputeCatalogItem[] = [
    {
        "description": 'price 19.9',
        "prices": {
            price: 19.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 50,
            "vcpu": 1,
            "memory": 512,
            "bandwidth": 5
        },
        "included": {
            "disk": 50,
            "bandwidth": 5
        },
        "diskAvailable": {
            "min": 50,
            "max": 100
        },
        "bandwidthAvailable": {
            "min": 5,
            "max": 100
        }
    },
    {
        "description": 'price 39.9',
        "prices": {
            price: 39.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 50,
            "vcpu": 1,
            "memory": 1024,
            "bandwidth": 10
        },
        "included": {
            "disk": 50,
            "bandwidth": 10
        },
        "diskAvailable": {
            "min": 50,
            "max": 100
        },
        "bandwidthAvailable": {
            "min": 10,
            "max": 100
        }
    },
    {
        "description": 'price 59.9',
        "prices": {
            price: 59.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 50,
            "vcpu": 2,
            "memory": 2048,
            "bandwidth": 20
        },
        "included": {
            "disk": 50,
            "bandwidth": 20
        },
        "diskAvailable": {
            "min": 50,
            "max": 100
        },
        "bandwidthAvailable": {
            "min": 20,
            "max": 100
        }
    },
    {
        "description": 'price 129.9',
        "prices": {
            price: 129.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 50,
            "vcpu": 4,
            "memory": 4096,
            "bandwidth": 30
        },
        "included": {
            "disk": 50,
            "bandwidth": 30
        },
        "diskAvailable": {
            "min": 50,
            "max": 100
        },
        "bandwidthAvailable": {
            "min": 30,
            "max": 100
        }
    },
    {
        "description": 'price 249.9',
        "prices": {
            price: 249.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 60,
            "vcpu": 4,
            "memory": 8192,
            "bandwidth": 40
        },
        "included": {
            "disk": 60,
            "bandwidth": 40
        },
        "diskAvailable": {
            "min": 60,
            "max": 100
        },
        "bandwidthAvailable": {
            "min": 40,
            "max": 100
        }
    },
    {
        "description": 'price 329.9',
        "prices": {
            price: 329.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 70,
            "vcpu": 8,
            "memory": 8192,
            "bandwidth": 50
        },
        "included": {
            "disk": 70,
            "bandwidth": 50
        },
        "diskAvailable": {
            "min": 70,
            "max": 100
        },
        "bandwidthAvailable": {
            "min": 50,
            "max": 100
        }
    },
    {
        "description": 'price 549.9',
        "prices": {
            price: 549.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 80,
            "vcpu": 8,
            "memory": 16384,
            "bandwidth": 70
        },
        "included": {
            "disk": 80,
            "bandwidth": 70
        },
        "diskAvailable": {
            "min": 80,
            "max": 500
        },
        "bandwidthAvailable": {
            "min": 70,
            "max": 100
        }
    },
    {
        "description": 'price 999.9',
        prices: {
            price: 999.9
        },
        "hardware": {
            "disk": 100,
            "vcpu": 8,
            "memory": 32768,
            "bandwidth": 100
        },
        "included": {
            "disk": 100,
            "bandwidth": 100
        },
        "diskAvailable": {
            "min": 100,
            "max": 500
        },
        "bandwidthAvailable": {
            "min": 100,
            "max": 100
        }
    },
    {
        "description": 'price 999.9',
        prices: {
            price: 999.9
        },
        "hardware": {
            "disk": 100,
            "vcpu": 16,
            "memory": 16384,
            "bandwidth": 100
        },
        "included": {
            "disk": 100,
            "bandwidth": 100
        },
        "diskAvailable": {
            "min": 100,
            "max": 500
        },
        "bandwidthAvailable": {
            "min": 100,
            "max": 100
        }
    },
    {
        "description": 'price 1399.9',
        prices: {
            price: 1399.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 100,
            "vcpu": 16,
            "memory": 32768,
            "bandwidth": 100
        },
        "included": {
            "disk": 100,
            "bandwidth": 100
        },
        "diskAvailable": {
            "min": 100,
            "max": 500
        },
        "bandwidthAvailable": {
            "min": 100,
            "max": 100
        }
    },
    {
        "description": 'price 1999.9',
        prices: {
            price: 1999.9,
            discount: {
                price: 0,
                period: 0
            }
        },
        "hardware": {
            "disk": 100,
            "vcpu": 16,
            "memory": 65536,
            "bandwidth": 100
        },
        "included": {
            "disk": 100,
            "bandwidth": 100
        },
        "diskAvailable": {
            "min": 100,
            "max": 500
        },
        "bandwidthAvailable": {
            "min": 100,
            "max": 100
        }
    }
]

const computesWithFixedDiskAvaiableMock = computesMock.map(compute => {
    return {
        ...compute, diskAvailable: {
            ...compute.diskAvailable,
            min: 60
        }
    }
});




export const pipeDisableBandMock: PipesDisabledConfigType = {
    available: 'bandwidthAvailable',
    currentProfile: 'bandwidth',
    serverCatalogProp: 'bandwidths'
}

export const pipeDisableDiskMock: PipesDisabledConfigType = {
    available: 'diskAvailable',
    currentProfile: 'disk',
    serverCatalogProp: 'disks'
}

export const pipesGenericMock: PipesGeneric = {
    value: '1',
    vcpu: 1,
    price: 1,
}

export const computesValMock: ComputeCatalogItem = {
    prices: {
        price: 1,
        discount: {
            price: 0,
            period: 0
        }
    },
    hardware: {
        disk: 1,
        vcpu: 1,
        memory: 1024,
        bandwidth: 10
    },
    included: {
        disk: 1,
        bandwidth: 1
    },
    diskAvailable: {
        min: 1,
        max: 100,
    },
    bandwidthAvailable: {
        min: 1,
        max: 100,
    },
    description: 'teste'
}

export const newComputesValMock: ComputeCatalogItem = {
    prices: {
        price: 1,
        discount: {
            price: 0,
            period: 0
        }
    },
    hardware: {
        disk: 1,
        vcpu: 5,
        memory: 2048,
        bandwidth: 50
    },
    included: {
        disk: 1,
        bandwidth: 1
    },
    diskAvailable: {
        min: 1,
        max: 100,
    },
    bandwidthAvailable: {
        min: 1,
        max: 100,
    },
    description: 'teste2'
}

export const hardwareSelectIndexMock: CurrentProfile = {
    compute: [1, console.log],
    bandwidth: [1, console.log],
    disk: [1, console.log]
}

export const computeIndexMock: number = 1;

export const pipesIndexMock: number = 1;

export const serverCatalogResponseMock: ServerCatalogResponse['serverCatalog'] = {
    priceGroup: 'teste',
    disks: {
        description: 'Discos',
        price: 0.4,
        sizes: [
            50,
            60,
            70,
            80,
            100,
            200,
            300,
            400,
            500
        ]
    },
    bandwidths: {
        description: 'Banda',
        price: 2.5,
        sizes: [
            5,
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            100
        ]
    },
    computes: computesMock
}

export const serverCatalogWithFixedMinAvaiableDisk: ServerCatalogResponse['serverCatalog'] = {
    priceGroup: 'teste',
    disks: {
        description: 'Discos',
        price: 0.4,
        sizes: [
            50,
            60,
            70,
            80,
            100,
            200,
            300,
            400,
            500
        ]
    },
    bandwidths: {
        description: 'Banda',
        price: 2.5,
        sizes: [
            5,
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            100
        ]
    },
    computes: computesWithFixedDiskAvaiableMock
}


export const imageResponseMock: Image[] = imagesMock
export const currentImageMock: number = 0